<template>
  <div class="main">
    <div class="hader_view" v-if="appList.length">
      <p>科目名称：{{ title }}</p>
      <el-button type="primary" @click="switchSubject">点击切换科目</el-button>
    </div>
    <div v-loading="loading" class="video_cascader" v-if="catalogueData.length">
      <!-- 视频列表 -->
      <div class="video_view">
        <ul v-if="oneState == true">
          <li
            class="chapter_veiw"
            v-for="(item, index) in catalogueData"
            :key="index"
            :class="oneObj.ID == item.ID ? 'blue' : ''"
            @click="oneChpter(item, index, 1)"
          >
            <p>{{ item.bookName }}</p>
          </li>
        </ul>
        <ul v-if="oneObj.children">
          <li
            class="joint_view"
            v-for="(item, index) in oneObj.children"
            :class="twoObj.ID == item.ID ? 'blue' : ''"
            @click="oneChpter(item, index, 2)"
            :key="index"
          >
            <p>{{ item.chapterName }}</p>
          </li>
        </ul>
        <ul v-if="twoObj.children">
          <li
            class="joint_view"
            :class="threeObj.ID == item.ID ? 'blue' : ''"
            @click="oneChpter(item, index, 3)"
            v-for="(item, index) in twoObj.children"
            :key="index"
          >
            <p>{{ item.summary }}</p>
          </li>
        </ul>
      </div>

      <!-- <el-cascader-panel
        ref="cascader"
        :options="catalogueData"
        @change="getVideoChapter"
        @expand-change="changeCasader"
        :props="propsCata"
        v-model="videoKey"
        clearable
      ></el-cascader-panel> -->
    </div>
    <div class="null_view" v-else>
      <p>医院尚未开放此功能</p>
    </div>
    <!-- 查询 -->
    <el-dialog
      title="查询"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="50%"
      class="dialog_view"
    >
      <el-cascader
        class="query"
        placeholder="请输入科目名称搜索"
        :options="appList"
        @change="toPlayUrl"
        @expand-change="changeaa"
        :props="props"
        filterable
      ></el-cascader>
      <div class="dialog_cascader">
        <el-cascader-panel
          v-model="cascaderArr"
          ref="singleCascader"
          :options="appList"
          @change="toPlayUrl"
          @expand-change="changeaa"
          :props="props"
        ></el-cascader-panel>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ksPcApi from "@/api/examPc";
import loginvuex from "@/store/index";
export default {
  data() {
    return {
      loading: false,
      appList: [],
      props: {
        // multiple: true,
        // checkStrictly: true,
        value: "id",
        label: "KsbClassName",
        children: "children",
      },
      propsCata: {
        // multiple: true,
        // checkStrictly: true,
        value: "ID",
        label: "bookName",
        children: "children",
      },
      catalogueData: [], // 章
      dialogVisible: false, // 查询弹窗
      title: "",
      appID: "",
      AppEName: "",
      videoKey: "",
      zindex: 0,
      sindex: 0,
      threeIndex: 0,
      oneObj: {},
      twoObj: {},
      threeObj: {},
      typeInit: false,
      oneState: true, // 是否有章
      rowItem: {},
      cascaderArr: "",
    };
  },
  props: ["cutcoms"],
  methods: {
    async init() {
      await this.getSubjectList();
      if (this.appID) {
        await this.getVideoSort("init");
      }
    },
    // 操作数据
    operateData(data) {
      data.forEach((item) => {
        item.id = item.AppID ? item.AppID : item.KsbClassID;
        if (item.applist || item.Childs) {
          item.children = item.applist ? item.applist : item.Childs;
          item.children.forEach((zitem) => {
            zitem.KsbClassName = zitem.KsbClassName
              ? zitem.KsbClassName
              : zitem.CName;
          });

          this.operateData(item.children);
        }
      });
    },
    async getSubjectList() {
      const obj = {
        hid: JSON.parse(loginvuex.state.hid),
      };
      this.loading = true;
      const { data } = await ksPcApi.subjectList(obj);
      if (data.Status == 200) {
        this.appList = data.Data;
        this.operateData(this.appList);
        this.title = this.appList[0]?.KsbClassName; // 初始化默认第一个
        this.appID = this.appList[0]?.applist[0].AppID;
        this.AppEName = this.appList[0]?.applist[0]?.AppEName;
        setTimeout(() => {
          this.loading = false;
        }, 500);
      } else {
        this.$message.error(data.Msg || data.Data);
      }
    },
    // 跳转
    toPlayUrl(val) {
      let AppEName = "";
      let row = {};
      this.appList.forEach((item) => {
        if (item.children) {
          item.children.forEach((zitem) => {
            if (val[val.length - 1] == zitem.AppID) {
              AppEName = zitem.AppEName;
              row = item;
            }
            if (zitem.children) {
              zitem.children.forEach((sitem) => {
                if (val[val.length - 1] == sitem.AppID) {
                  AppEName = sitem.AppEName;
                  row = item;
                }
              });
            }
          });
        }
      });
      row.children.forEach((item) => {
        if (item.children) {
          item.children.forEach((zitem) => {
            if (zitem.id == val[val.length - 1]) {
              this.title = zitem.KsbClassName;
            }
          });
        } else {
          if (item.id == val[val.length - 1]) {
            this.title = item.KsbClassName;
          }
        }
      });
      this.appID = val[val.length - 1];
      this.AppEName = AppEName;
      // console.log(row,'row',val);
      // 找出对应的
      if (row.children && this.appID) {
        const item = row.children.filter((sitem) => {
          return sitem.AppID == this.appID;
        });
        // console.log(item[0]);
        if (item[0]?.IsBook == 1) {
          // 特殊处理 没有章，直接请求节
          item[0].state = false;
          this.oneState = false;
          this.rowItem = item[0];
          this.getVideoChapter(item[0], 0, "isBook");
        } else {
          this.oneState = true;
          this.getVideoSort();
        }
        this.dialogVisible = false;
      }
      this.cascaderArr = val;
      // console.log(row, "row", val, this.appID);
    },
    // 切换科目
    switchSubject() {
      this.dialogVisible = true;
      this.changeaa([this.appList[0].id], "init"); // 展开级联
    },
    // 默认全部展开
    changeaa(val, type) {
      //   const value = val.length == 1 ? val[0]
      if (val.length && !this.cascaderArr) {
        this.$nextTick(() => {
          let node = this.$refs.singleCascader.menus; // 当前节点数组 ?  val[0].KsbClassID : val[0]
          let caspanel = this.$refs.singleCascader;
          let userArr = [];
          userArr = node[0].filter((item) => {
            return item.value == val[0];
          });
          caspanel.handleExpand(userArr[0], true);
          if (val.length >= 2) {
            const arr = userArr[0]?.children.filter((item) => {
              return val[val.length - 1] == item.value;
            });
            caspanel.handleExpand(arr[0], true);
          } else {
            caspanel.handleExpand(userArr[0]?.children[0], true);
          }
        });
      }
    },
    // 默认全部展开视频列表
    changeCasader(val) {
      if (val.length) {
        this.$nextTick(() => {
          let node = this.$refs.cascader.menus; // 当前节点数组 ?  val[0].KsbClassID : val[0]
          let caspanel = this.$refs.cascader;
          let userArr = [];
          userArr = node[0].filter((item) => {
            return item.value == val[0];
          });
          caspanel.handleExpand(userArr[0], true);
          caspanel.handleExpand(userArr[0]?.children[0], true);

          if (val.length >= 2) {
            const arr = userArr[0]?.children.filter((item) => {
              return val[val.length - 1] == item.value;
            });
            caspanel.handleExpand(arr[0], true);
          } else {
            caspanel.handleExpand(userArr[0]?.children[0], true);
          }
        });
        // this.$refs.cascader.$refs.menu[0].panel.clearCheckedNodes()
        // this.$refs.cascader.$refs.menu[0].panel.activePath = []
        // console.log(this.$refs.cascader.$refs.menu[0].panel.activePath,'选中状态');
        // console.log(this.$refs.cascader,'选中状态');
        // this.reset()
      }
    },
    reset() {
      this.videoKey = []; //v-model绑定值清空
      this.$nextTick(() => {
        // 清空级联选择器选中状态
        this.$refs.cascader.$refs.panel.clearCheckedNodes();
        // 清除⾼亮
        this.$refs.cascader.$refs.panel.activePath = [];
      });
    },
    // 获取视频章节
    async getVideoSort(type) {
      const obj = {
        appID: this.appID,
      };
      const { data } = await ksPcApi.getVideoCatalogue(obj);
      if (data.Status == 200) {
        this.catalogueData = data.Data.map((item) => {
          item.state = false;
          item.expand = false;
          item.bookName = item.bookName.split("_")[0];
          item.ID = item.bookID; // 统一ID字段名
          return item;
        });
        this.oneObj = this.catalogueData[0];
        this.getVideoChapter(this.catalogueData[0], 0, "init");
      } else {
        this.$message.error(data.Msg || data.Data);
      }
    },
    // 获取视频章下面的小节
    async getVideoChapter(val, index, type) {
      if (val.state == false) {
        const obj = {
          appEName: val.IsBook == 1 ? val.TrueAppEName : this.AppEName,
          bookID: val.IsBook == 1 ? val.AppID : val.bookID,
        };
        this.loading = true;
        const { data } = await ksPcApi.videoChapter(obj);
        if (data.Status == 200) {
          this.catalogueData[index].children = data.Data;
          this.catalogueData[index].state = true;
          this.zindex = index;
          //   this.catalogueData[index].children = data.Data;
          this.catalogueData[index].children.forEach((item) => {
            item.bookName = item.chapterName;
            item.children = item.names;
            item.ID = item.chapterID;
            item.state = false;
            if (item.children) {
              item.children.forEach((zitem) => {
                zitem.bookName = zitem.summary;
                zitem.ID = zitem.id;
              });
            }
          });
          //   if (type == "init") {
          this.twoObj = this.catalogueData[index].children[0];
          this.threeObj = this.catalogueData[index].children[0].children[0];
          //   }
          setTimeout(() => {
            this.loading = false;
          }, 500);
        } else {
          this.$message.error(data.Msg || data.Data);
          this.loading = false;
        }
      } else {
        // this.catalogueData[index].expand = !val.expand;
        // 不需要请求接口
        this.twoObj = this.catalogueData[index].children[0];
        this.threeObj = this.catalogueData[index].children[0].children[0];
      }
    },
    oneChpter(item, index, type) {
      if (type == 1) {
        this.oneObj = item;
        this.zindex = index;
        this.threeObj = {};
        this.getVideoChapter(item, index);
      } else if (type == 2) {
        this.twoObj = item;
        this.sindex = index;
      } else {
        this.threeObj = item;
        this.threeIndex = index;
        // this.$router.push({
        //   path: "/videoData/getVideoUrl",
        //   query: {
        //     appID: this.appID,
        //     AppEName:
        //       this.oneState == true ? this.AppEName : this.rowItem.TrueAppEName,
        //     bookID:
        //       this.oneState == true ? this.oneObj.bookID : this.rowItem.AppID,
        //     chapterID: this.twoObj.chapterID,
        //     id: item.id,
        //     newType: item.newType,
        //     oneState: this.oneState == true ? 0 : 1,
        //   },
        // });
        const obj = {
          appID: this.appID,
          AppEName:
            this.oneState == true ? this.AppEName : this.rowItem.TrueAppEName,
          bookID:
            this.oneState == true ? this.oneObj.bookID : this.rowItem.AppID,
          chapterID: this.twoObj.chapterID,
          id: item.id,
          newType: item.newType,
          oneState: this.oneState == true ? 0 : 1,
        };
        this.$parent.rowObj = obj;
        this.cutcoms(1);
        // 缓存上次选择的科目
        // const obj = {
        //   appID: this.appID,
        //   bookID:
        //     this.oneState == true ? this.oneObj.bookID : this.rowItem.AppID,
        //   appEName:
        //     this.oneState == true ? this.AppEName : this.rowItem.TrueAppEName,
        //   title: this.title,
        // };
        // sessionStorage.setItem("cacheRecord", JSON.stringify(obj));
      }
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.main {
  min-height: 780px;
  padding: 24px;
  .hader_view {
    display: flex;
    align-items: center;
    margin-bottom: 46px;
    > P {
      margin-right: 24px;
      font-weight: bold;
    }
  }
}
.dialog_cascader {
  ::v-deep .el-cascader-menu {
    min-width: 240px;
    text-align: center;
    // height: 400px;
    .el-cascader-menu__list {
      padding: 0 !important;
    }
    .el-cascader-node {
      border-bottom: 1px solid #e4e7ed;
      border-right: 1px solid #e4e7ed;
      height: 60px;
    }
    .el-scrollbar__wrap {
      height: 600px;
    }
  }
  ::v-deep .el-cascader-panel {
    height: 400px;
  }
}
.query {
  margin-bottom: 24px;
}

::v-deep .el-cascader-node:not(.is-disabled):hover {
  background: #d7eff9 !important;
}
.video_cascader {
  ::v-deep .el-cascader-menu {
    min-width: 240px;
    text-align: center;
    // height: 400px;
    .el-cascader-menu__list {
      padding: 0 !important;
    }
    .el-cascader-node {
      border-bottom: 1px solid #e4e7ed;
      border-right: 1px solid #e4e7ed;
      height: 60px;
    }
    .el-scrollbar__wrap {
      height: 600px;
    }
  }
  //   ::v-deep .el-cascader-panel {
  //     height: 00px;
  //   }
}
.video_view {
  border: 1px solid #e1e3e1;
  display: flex;
}
ul {
  list-style: none;
  height: 600px;
  overflow-y: auto;
}
.chapter_veiw {
  width: 450px;
  min-height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #e1e3e1;
  border-right: 1px solid #e1e3e1;
  padding: 0px 14px;
  > p {
    font-size: 16px;
  }
  &:hover {
    // background: #47a4fc;
    background: #f3f3f3;
    // color: #fff;
  }
}
.joint_view {
  width: 340px;
  min-height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #e1e3e1;
  border-right: 1px solid #e1e3e1;
  padding: 0px 24px;
  > p {
    font-size: 14px;
  }
  &:hover {
    // background: #47a4fc;
    background: #f3f3f3;
    // color: #fff;
  }
}
.blue {
  color: #2d9aff;
  background: #d7eff9;
}
.null_view {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 620px;
  width: 100%;
  > p {
    font-size: 22px;
    font-weight: bold;
    letter-spacing: 4px;
  }
}
</style>